const carouselItems = [
  {
    tag: '重磅爆料',
    title: '2026暑期档明星恋情大揭秘：多对CP浮出水面',
    summary: '近日多位顶流艺人被拍到与神秘异性同框出行，引发全网热议。知情人透露其中涉及多位一线明星，细节正在进一步核实中。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20paparazzi-style%20scene%20with%20silhouetted%20figures%20against%20warm%20city%20night%20lights%2C%20soft%20bokeh%20background%2C%20editorial%20celebrity%20news%20photography%20style%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones%2C%20clean%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '综艺聚焦',
    title: '热门综艺节目录制现场突发状况，导演组紧急调整方案',
    summary: '某S+级综艺节目最新录制现场出现意外插曲，嘉宾阵容或将面临重大调整，节目组已发布官方声明回应外界关切。',
    img: 'https://readdy.ai/api/search-image?query=A%20behind-the-scenes%20TV%20studio%20scene%20with%20professional%20lighting%20equipment%20and%20cameras%2C%20warm%20stage%20lighting%2C%20modern%20broadcast%20studio%20interior%2C%20clean%20professional%20setting%2C%20atmospheric%20with%20soft%20shadows&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '网红追踪',
    title: '头部网红带货翻车事件持续发酵，品牌方紧急回应',
    summary: '拥有千万粉丝的知名带货主播近期陷入产品质量争议，多个合作品牌已发布声明，事件影响范围仍在持续扩大。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20social%20media%20live%20streaming%20setup%20with%20smartphone%20and%20ring%20light%2C%20product%20display%20table%2C%20trending%20notification%20visualization%2C%20warm%20neutral%20background%2C%20clean%20professional%20e-commerce%20aesthetic&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '影视快讯',
    title: '下半年最受期待影视剧大盘点：多部大制作确认定档',
    summary: '2026年下半年影视市场即将迎来多部重磅作品，涵盖古装大剧、都市情感、悬疑探案等多种类型，观众期待值拉满。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20film%20set%20atmosphere%20with%20movie%20clapperboard%20and%20director%20chair%2C%20warm%20golden%20hour%20lighting%2C%20film%20reel%20and%20poster%20aesthetic%2C%20dramatic%20composition%2C%20artistic%20movie%20production%20theme&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-flashlight-line text-sm"></i>
            焦点专题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">精选近期最受关注的热门专题报道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 flex-1">
                  {item.summary}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-time-line mr-1"></i>2小时前
                  </span>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}